import React, {Component, PropTypes} from "react";
import {connect} from 'react-redux'
import {changeCustomerEmail,requestChangeCustomerEmail} from '../actions'
import CustomerEmailField from './CustomerEmailField';
import {Nav, NavItem, Modal} from 'react-bootstrap';

class CustomerEmailFieldGroup extends Component {
    static childContextTypes= {
        location: React.PropTypes.object
    }
    static contextTypes = {
        router: React.PropTypes.object
    }

    constructor(props) {
        super(props);
        const {formAssigneeEmail, formId, username} = props;

        let emails = formAssigneeEmail.split(";");
        let emailsEdit = formAssigneeEmail.split(";");
        for (let i = 0; i < 7 - emails.length ; i++) {
            emailsEdit.push("");
        }
        this.state = {
            open: true,
            newemail: true,
            formAssigneeEmail: formAssigneeEmail,
            formId: formId,
            username: username,
            emails: emails,
            emailsEdit: emailsEdit,
            emailEditModal: false

        };
        //debugger;
    }

    getInitialState() {
        return {
            "formAssigneeEmail": this.props.formAssigneeEmail
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({...nextProps});
    }

    onStateChange = (e) => {
        e.preventDefault();
        this.setState({
            "newemail": !this.state.newemail
        });
    }

    onEmailChange(event) {
        //debugger;
        // emailsEdit.forEach((value, inx) => {
        //     if (index === inx) {
        //         return newvalue
        //     } else {
        //         return value
        //     }
        // })
        const { emailsEdit} = this.state;
        const index = Number.parseInt(event.target.name.split("_")[2]);
        const newvalue = event.target.value;
        //debugger;
        emailsEdit[index] = newvalue;
        console.log(newvalue)
        this.setState({
            "emailsEdit": emailsEdit
        });
    }

    showModal() {
        this.setState({
            "emailEditModal": true
        })
    }
    hideModal() {
        this.setState({
            "emailEditModal": false
        })
    }

    onAddButtonClick(formId) {
        this.props.dispatch(requestChangeCustomerEmail(formId))
    }

    onSaveButtonClick() {
        const { formId, formAssigneeEmail, email, emailsEdit, origemail } = this.state;
        const { forms, formsList } = this.props;
        // //TODO: update formAssigneeEmail with new email value
        // var emaillist = formAssigneeEmail.split(";");
        // if (origemail !== "") {
        //     emaillist.forEach((item, index) => {
        //         if (item === origemail) {
        //             console.log("found " + item);
        //             emaillist[index] = email;
        //         }
        //     })
        //
        // } else {
        //     emaillist = emaillist.concat(email);
        // }
        // remove empty strings if any exist
        const emaillist = emailsEdit.filter(item => { return item != ""});
        this.setState({
            "open": !this.state.open,
            "hidenew": true,
            "emailEditModal": false,
            "emails":  emaillist,
            "formAssigneeEmail": emaillist.join(';')
        });
        //debugger;
        console.log(emaillist)
        this.props.dispatch(changeCustomerEmail(formId, {"formAssigneeEmail": emaillist.join(';')}, forms, formsList))
        this.context.router.push('/');
    }

    render() {
        const {formAssigneeEmail, formId,  username,emailEditModal, emails,emailsEdit} = this.state;
        const {emailEditShowModal,emailEditFormId} = this.props;

        return (
            <div key={"emailgroup" + formId}>
                {emails.map((contactemail,index) =>
                    <div key={formId + contactemail + index}>{contactemail}<br /></div>
               )}

                <button type="button" onClick={this.showModal.bind(this)} className="btn btn-link" aria-label="Left Align" title="Save changes">
                    <span className="glyphicon glyphicon-pencil" style={{fontSize: "0.8em"}} aria-hidden="true"></span>
                </button>
                <Modal show={emailEditModal} onHide={this.close}>
                    <Modal.Body>
                        <h2 style={{textAlign: 'center'}}>Edit customer contacts (email) with access to this survey</h2>

                        <input type="text" placeholder="Customer email 1" size="35"
                               value={emailsEdit[0]}  key={"emailedit_" + formId + "_0"} name={"emailedit_" + formId + "_0"} onChange={(event) => this.onEmailChange(event)}></input><br/>
                        <input type="text" placeholder="Customer email 2" size="35"
                               value={emailsEdit[1]}  key={"emailedit_" + formId + "_1"} name={"emailedit_" + formId + "_1"} onChange={(event) => this.onEmailChange(event)}></input><br/>
                        <input type="text" placeholder="Customer email 3" size="35"
                               value={emailsEdit[2]}  key={"emailedit_" + formId + "_2"} name={"emailedit_" + formId + "_2"} onChange={(event) => this.onEmailChange(event)}></input><br/>
                        <input type="text" placeholder="Customer email 4" size="35"
                               value={emailsEdit[3]}  key={"emailedit_" + formId + "_3"} name={"emailedit_" + formId + "_3"} onChange={(event) => this.onEmailChange(event)}></input><br/>
                        <input type="text" placeholder="Customer email 5" size="35"
                               value={emailsEdit[4]}  key={"emailedit_" + formId + "_4"} name={"emailedit_" + formId + "_4"} onChange={(event) => this.onEmailChange(event)}></input><br/>
                        <input type="text" placeholder="Customer email 6" size="35"
                               value={emailsEdit[5]} key={"emailedit_" + formId + "_5"} name={"emailedit_" + formId + "_5"} onChange={(event) => this.onEmailChange(event)}></input><br/>
                        <input type="text" placeholder="Customer email 7" size="35"
                               value={emailsEdit[6]}  key={"emailedit_" + formId + "_6"} name={"emailedit_" + formId + "_6"} onChange={(event) => this.onEmailChange(event)}></input><br/>

                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-comments" onClick={this.onSaveButtonClick.bind(this)}>Save</button> <button className="btn btn-comments" onClick={() => this.hideModal()}>Close</button>
                    </Modal.Footer>
                </Modal>


            </div>
      );
    }
}

CustomerEmailFieldGroup.defaultProps = {
    open: false
};


function mapStateToProps(state) {
    const {forms,form} = state
    const isFetching = forms.isFetching

    return {
        forms,
        formsList: forms.formsList,
        form,
        emailEditShowModal: forms.emailEditShowModal,
        emailEditFormId: form.emailEditFormId

    }
}

export default connect(mapStateToProps)(CustomerEmailFieldGroup)




// WEBPACK FOOTER //
// ./src/containers/CustomerEmailFieldGroup.js